import { isShobiddak } from './domain';

export const generateOpenSooqRedirectUrl = (url = '', country = '', lang = ''): string => {
  if (isShobiddak()) return url.replace('{country}.', '').replace('/{lang}', '');

  return url.replace('{country}', country).replace('{lang}', lang);
};

export const getOpenSooqSiteUrl = (country: string, lang: string): string =>
  generateOpenSooqRedirectUrl(process.env.REACT_APP_OPENSOOQ_BASE, country, lang);

interface LogoDimensions {
  width: number;
  height: number;
}

const OPENSOOQ_LOGO: LogoDimensions = { width: 269, height: 56 };
const SHOBIDDAK_LOGO: LogoDimensions = { width: 106, height: 42 };

export const getLogoDimensions = (): LogoDimensions =>
  isShobiddak() ? SHOBIDDAK_LOGO : OPENSOOQ_LOGO;
